import { WidgetDescription } from 'controls/designer/features/widgets/types';
import ExportWidget from 'controls/designer/features/widgets/export/widget';
import { ExportWidgetConfig, ExportWidgetType } from 'controls/designer/features/widgets/export/types';
import Configuration from './configuration';
import { i18n } from './localization';


export function getWidgetDescription(): WidgetDescription<ExportWidgetConfig> {
	return {
		form: Configuration,
		defaultConfig: {
			type: ExportWidgetType,
			title: i18n('Export'),
		},
		width: 60,
		height: 60,
		widget: ExportWidget,
		fullTitle: i18n('Export'),
		preProcessConfig: (config: ExportWidgetConfig) => {
			config = JSON.parse(JSON.stringify(config));
			return config;
		},
		containerStyle: {
			noBorder: true,
			transparent: true,
			header: 'on-hover',
		},
	};
}
